import { Component, effect, input, signal, untracked } from '@angular/core';

@Component({
  selector: 'app-media-image',
  standalone: true,
  templateUrl: './media-image.component.html',
  styleUrl: './media-image.component.scss',
  host: {
    '[class.is-fill]': 'fill()',
    '[class.is-sm]': 'size() === "sm"',
    '[class.is-loaded]': 'loaded()',
    '[class.is-failed]': 'failed()',
    '[style.--media-fit]': 'fit()',
    '[attr.aria-busy]': 'loaded() ? null : true',
  },
})
export class MediaImageComponent {
  readonly src = input.required<string>();
  readonly alt = input('');
  readonly fit = input<'contain' | 'cover'>('cover');
  readonly loading = input<'lazy' | 'eager'>('lazy');
  readonly fill = input(true);
  readonly size = input<'md' | 'sm'>('md');
  readonly kind = input<'image' | 'video'>('image');
  readonly poster = input<string | null>(null);
  readonly fallback = input('');

  readonly loaded = signal(false);
  readonly failed = signal(false);
  readonly displaySrc = signal('');

  constructor() {
    effect(() => {
      const next = this.src()?.trim() ?? '';
      untracked(() => {
        this.failed.set(false);
        this.displaySrc.set(next);
        this.loaded.set(!next);
      });
    });
  }

  onReady(): void {
    this.loaded.set(true);
    this.failed.set(false);
  }

  onError(): void {
    const fallback = this.fallback().trim();
    if (fallback && this.displaySrc() !== fallback) {
      this.displaySrc.set(fallback);
      this.loaded.set(false);
      return;
    }
    this.failed.set(true);
    this.loaded.set(true);
  }
}
